import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationService } from '../../../../../core/services/notification/notification.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { TransactionResult } from '../../../../../core/services/interfaces/transaction-result';
import { IEquipmentTypes } from '../../Interfaces/IEquipmentTypes';
import { EquipmentTypesService } from '../../services/equipmenttypes-service';
import { TranslateService } from '../../../../../core/services/translate-service';
import { TranslateApplicationService } from '../../../../../core/translate/translate-application-service';


@Component({
  selector: 'app-equipmenttypes-detail',
  templateUrl: './equipmenttypes-detail.component.html',
  styleUrls: ['./equipmenttypes-detail.component.scss']
})
export class EquipmentTypesDetailComponent implements OnInit {

  formGroup: FormGroup;
  loading = false;
  selectedFile: FileList;
  list: any[] = [
    { Id: 1, Name: "Nombre 1" },
    { Id: 2, Name: "Nombre 2" },
    { Id: 3, Name: "Nombre 3" }
  ];
  max_characters: string = "";

  constructor(
    private dialogRef: MatDialogRef<EquipmentTypesDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IEquipmentTypes,
    private notificationService: NotificationService,
    private translateService: TranslateService,
    private service: EquipmentTypesService,
    private formBuilder: FormBuilder,
    public translate: TranslateApplicationService
  ) {
    this.formGroup = this.formBuilder.group({
      pkequipmenttype: [data.pkequipmenttype == null ? 0 : data.pkequipmenttype],
      txtequipmenttype: [
        data.equipmenttype,
        [
          Validators.required,
          Validators.maxLength(255),
          Validators.pattern('.*[a-zA-Z].*')
        ]
      ],
      txtdescription: [
        data.description,
        [
          Validators.required,
          Validators.maxLength(255),
          Validators.pattern('.*[a-zA-Z].*')
        ]
      ],
    });
  }
  ngOnInit(): void {
    let max_char = this.translate.TranslateKey('max_characteres');
    this.max_characters = max_char.replace('{{ number_max }}', '255');
  }

  //button save for add/edit
  Save() {
    this.loading = true;
    if((this.formGroup.controls.txtequipmenttype.value != null && this.formGroup.controls.txtdescription.value != null) &&
       (this.formGroup.controls.txtequipmenttype.value.trim() != "" && this.formGroup.controls.txtdescription.value.trim() != "")) {
      this.loading = true;
      
      if (this.formGroup.controls.pkequipmenttype.value == 0) {
        this.service.AddEquipmentType(this.formGroup.value).subscribe(
          (result: TransactionResult<boolean>) => {
            if (result.success) 
            { 
              this.Alert(); this.dialogRef.close(true); 
            }
            else{
              //this.ErrorAlert(result.message);
              this.loading = false;
            }
          },
          (error: any) => { this.ErrorAlert(error); this.loading = false; }
        );
      }
      else {
        this.service.EditEquipmentType(this.formGroup.value).subscribe(
          (result: TransactionResult<boolean>) => {
            if (result.data) { 
              this.Alert(); this.dialogRef.close(true); 
            }
            else{
              //this.ErrorAlert(result.message);
              this.loading = false;
            }
          },
          (error: any) => { this.ErrorAlert(error); this.loading = false; }
        );
      }
    }
    else{
      this.loading = false;
      this.notificationService.AddAlert({
        icon: 'all_inbox',
        title: 'Warning',
        message: this.translate.TranslateKey('COMPLETE_FORM'),
        shown: true
      });
    }
  }


  Close() {
    this.dialogRef.close(true);
  }

  Alert() {
    this.notificationService.AddAlert({
      icon: 'all_inbox',
      title: 'Success',
      message: this.translate.TranslateKey('COMPLETE'),
      shown: true
    });
  }

  ErrorAlert(message: any) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Error',
			message: message,
			shown: true,
		});
	}
}
